import { cn } from "@/lib/utils";

interface AuthSegmentedTabsProps {
  value: "manager" | "employee";
  onChange: (value: "manager" | "employee") => void;
}

const OPTIONS: Array<{ value: "manager" | "employee"; label: string; description: string }> = [
  { value: "manager", label: "Gérant", description: "J'ouvre un nouvel espace" },
  { value: "employee", label: "Salarié(e)", description: "J'ai reçu une invitation" },
];

export function AuthSegmentedTabs({ value, onChange }: AuthSegmentedTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Type de compte"
      className="grid grid-cols-2 gap-1.5 p-1.5 rounded-2xl bg-muted/40 border border-border/50"
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.value)}
            className={cn(
              "relative flex flex-col items-center justify-center gap-0.5 rounded-xl px-3 py-2.5 text-center transition-[background-color,color,box-shadow] duration-base ease-out-expo focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              active
                ? "bg-background shadow-soft text-foreground"
                : "bg-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            <span className={cn("text-sm font-semibold", active && "text-primary")}>{opt.label}</span>
            <span className="text-xs text-muted-foreground leading-tight">{opt.description}</span>
          </button>
        );
      })}
    </div>
  );
}
